export default "__VITE_ASSET__DPnIJsej__"